import api from '@/services/api'
import type {
  ApiKeyListResponse,
  ActiveApiKeysResponse,
  RevokedApiKeysResponse,
  CreateApiKeyResponse
} from './types'
import type { DataViewFilters } from '@/services/types'

const getActiveApiKeys = async (params?: DataViewFilters): Promise<ActiveApiKeysResponse> => {
  const response = await api.get<ApiKeyListResponse>('/api-keys', {
    params: { ...params, status: 'active' }
  })
  const keys = response.data.keys || []
  return { active_api_keys: keys, total: response.data.total ?? keys.length }
}

const getRevokedApiKeys = async (params?: DataViewFilters): Promise<RevokedApiKeysResponse> => {
  const response = await api.get<ApiKeyListResponse>('/api-keys', {
    params: { ...params, status: 'revoked' }
  })
  const keys = response.data.keys || []
  return { revoked_api_keys: keys, total: response.data.total ?? keys.length }
}

const createApiKey = async (label: string): Promise<CreateApiKeyResponse> => {
  const response = await api.post<CreateApiKeyResponse>('/api-keys', { label })
  return response.data
}

const deleteApiKey = async (id: number): Promise<boolean> => {
  try {
    const response = await api.delete(`/api-keys/${id}`)
    return response.status >= 200 && response.status < 300
  } catch (error) {
    return false
  }
}

export default { getActiveApiKeys, getRevokedApiKeys, createApiKey, deleteApiKey }
